import { render, staticRenderFns } from "./MainHolder.vue?vue&type=template&id=05afd1b6&scoped=true&"
import script from "./MainHolder.vue?vue&type=script&lang=js&"
export * from "./MainHolder.vue?vue&type=script&lang=js&"
import style0 from "./MainHolder.vue?vue&type=style&index=0&id=05afd1b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05afd1b6",
  null
  
)

export default component.exports